<template>
  <section class="sec-top-intro">
    <div class="box-top-slide">
      <div class="img-top-slide">
        <img src="@/assets/img/column/2025special_01.jpg" />
      </div>
      <div class="img-top-slide_text">
        <h2 class="mb-0 text-left"><span>バランス良く美肌を目指すコツは？</span><br>ビタミンD3の美容効果とUVケアの関係。</h2>
      </div>
    </div>
  </section>

  <section class="column_content">

    <h2 class="my-5 pt-5">98%の日本人が足りてないといわれる、ビタミンD。<br>実は美容効果の高い<br>美肌の栄養素って知ってますか？</h2>
    
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/2025special_02.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <h3 class="mb-3">実は海外ではメジャーなビタミンDは、見逃されがちな“美肌の鍵”</h3>
        <p class="mb-3">「ビタミンD」足りていますか？</p>
        <p class="mb-3">日本人の98%が不足しているという研究結果がある「ビタミンD」*1。</p>
        <p class="mb-3">ビタミンDは大きく分けてビタミンD2とビタミンD3に分類され、日光を浴びることで皮膚で生成されるという特徴をもつビタミンです。</p>
        <p class="mb-3">美容に詳しい方であれば耳にしたことがあるかもしれませんが、特に近年ビタミンD3は、美肌や健康のために摂取したい栄養素として日本で広まってきています。</p>
        <p>というのも、米国をはじめ海外では「骨の健康維持」だけではなく、「代謝・免疫力アップ」から「抗炎症作用」まで、全身の細胞に効用をもつ万能なビタミンとして重宝されています。</p>
      </div>
    </div>
    
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <h3 class="mb-3">ビタミンD3の美容効果は？肌、爪、髪に効果的◎</h3>
        <p class="mb-3">近年注目されている「ビタミンD」。</p>
        <p class="mb-3">ビタミンDは脂溶性ビタミンの一種で、主に以下の2種類があります：</p>
        <ul class="mb-3">
          <li>ビタミンD2（植物由来）</li>
          <li>ビタミンD3（動物由来・日光合成）</li>
        </ul>
        <p class="mb-3">では美容にフォーカスした場合、どんな嬉しい効果を期待できるのかみていきましょう。</p>
        <p class="mb-3"><strong>・コラーゲン生成を助け、肌のハリや弾力につながる</strong></p>
        <p class="mb-3"><strong>・肌のターンオーバーを（肌の生まれ変わり）を正常化</strong></p>
        <p class="mb-3"><strong>・抗炎症作用が肌荒れやニキビを予防</strong></p>
        <p class="mb-3"><strong>・肌のバリア機能がアップし、乾燥を予防してくれる</strong></p>
        <p class="mb-3"><strong>・“インナーUVケア”として、肌の抵抗力を高める働きも</strong></p>
        <p class="mb-3"><strong>・爪や髪の毛の健康強化</strong></p>
        <p>女性はもちろん、男性にとっても摂取したくなる効果効能が多くあることがわかります。</p>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/2025special_03.jpg">
      </div>
    </div>
    
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/2025special_04.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <h3 class="mb-3">ビタミンD3と日光の関係</h3>
        <p class="mb-3">ビタミンD3が、美容や健康にとってメリットがある栄養素だということは分かりましたが、ではなぜ日本人は98%の方が不足しているのでしょうか。</p>
        <p class="mb-3">冒頭でも触れましたが、ビタミンD3は日光（紫外線）を浴びることで生成されます。</p>
        <p class="mb-3">きれいな肌を目指すために、毎日しっかり日焼け止めを塗っている人も多いと思いますが、<strong>その“紫外線対策”が原因で、多くの人がビタミンD3不足に陥っているのです</strong>。</p>
        <p class="mb-3">本来、ビタミンD3は日光を浴びることで体内で合成されるもの。ところが現代人は…</p>
        <ul class="mb-3">
          <li>紫外線対策の徹底（UVカット・日傘・サングラス）</li>
          <li>屋内中心の生活、デスクワーク・リモート勤務</li>
          <li>魚やキノコなどのD3豊富な食品を日常的に摂っていない</li>
        </ul>
        <p>このような背景から、<strong>自然にD3を十分摂取するのは難しい</strong>のが現実です。</p>
      </div>
    </div>
    
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <h3 class="mb-3">日常生活でビタミンD3を摂取するには？</h3>
        <p class="mb-3">日常生活の中で、ビタミンD3を摂取するには、大きく分けて2つの方法があります。</p>
        <p class="mb-3"><strong>・日光を浴びる</strong></p>
        <p class="mb-3">1日に必要なビタミンD3は10μg（マイクロは100万分の1）といわれており、これを紫外線から生成するためには、一般的に朝15〜30分程度の日光浴をすることが必要といわれています。</p>
        <p class="mb-3"><strong>・食事から摂取する</strong></p>
        <p class="mb-3">ビタミンD3を多く含む食材は多くなく、代表的なものは魚類、次いできのこ類や卵（卵黄）です。</p>
        <p>食材だけ見ると、日本人の理想的な朝ごはんを想像できますね。一方で近年の食生活の変化により、このような健康的な食事を取れていない人が多いこともビタミンD3不足の要因のひとつだと考えられます。</p>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/2025special_05.jpg">
      </div>
    </div>
    
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/2025special_06.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <h3 class="mb-3">ビタミンD3を効率的に摂取する方法</h3>
        <p class="mb-3">日光浴や食事など、健康的な生活を送っている方は自然に摂取できていそうなビタミンD3。</p>
        <p class="mb-3">しかし忙しい日常の中では、そう理想的に摂取できないのが現状でしょう。</p>
        <p class="mb-3">そこでやはり活用したいのは、吸収率と手軽さに優れた<strong>「サプリメント」</strong>。</p>
        <p class="mb-3">ビタミンD3は多く摂取しすぎることも、推奨されていません。</p>
        <p>1日に必要な適正量を摂ることができるサプリメントを、うまく活用して健やかな美肌を目指したいものです。</p>
      </div>
    </div>
    
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <h3 class="mb-3">美肌を目指すために。<br>ビタミンD3と同時に意識したいUVケア</h3>
        <p class="mb-3">ビタミンD3のもつ美容や健康への嬉しい効用について紹介しました。</p>
        <p class="mb-3">また、適量であれば日光を浴びることにメリットがあることもわかりましたが、やはり美肌・美白を目指す方にとってはできる限り避けたいもの。</p>
        <p class="mb-3">紫外線は「百害あって一利のみ」ともいわれます。</p>
        <p class="mb-3">この"一利"は、ビタミンD3が合成される点です。</p>
        <p class="mb-3">ビタミンD3はサプリメントや食事から摂取しつつ、UVケア対策は日常から行う。</p>
        <p>このバランスをぜひ意識していただくことをおすすめします。</p>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/2025special_07.jpg">
      </div>
    </div>

    <div class="layer_01  my-5 py-5">
      <img src="@/assets/img/column/layer-bg_01.jpg">
      <div class="layer-text">
        <p class="fs-2">美容の栄養素ビタミンD3</p>
        <p class="mb-3">「ビタミンD3」を活用しつつ、素肌も身体も健やかに。</p>
        <p class="mb-3">大切なのは健康的な食生活、日常的な紫外線対策、不足している分はサプリメントで補う。</p>
        <p class="mb-3">忙しい日常生活の中で、自分のご機嫌をとるのも自分です。</p>
        <p class="mb-3">サプリメントやスキンケアアイテムを頼っていいんです。</p>
        <p>無理せずに続けられるご自身の方法で、お気に入りのアイテムで、<br>明日の自分のために、美肌づくりを。</p>
      </div>
    </div>
    
  </section>


  <!-- トップに戻るボタン -->
  <button id="page-top" class="btn" v-on:click="scrollTop">
    TOP
  </button>

</template>

<style scoped>
.column_content h2,.column_content h3 {
  font-weight: 500 !important;
}
small {
  font-size: .7em;
}
ul {
  list-style: disc;
  margin-left: 25px;
}

.feature-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 50px;
}
.feature-row_item_image img {
  width: 100%;
}
.feature-row_item_text h3 {
  font-size: 1.25em;
}

button#page-top {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 100;
}


.layer_01 {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url('../../assets/img/column/layer-bg_01.jpg');
  background-size: cover;
  background-position: center;
  min-height: 500px; /* 最小高さを設定しておくと、極端に小さくなるのを防げます */
  padding: 20px; /* テキストと画像の端の間に余白を設定 */
}
.layer_01 img {
  display: none; /* 画像は背景として使用するので非表示にします */
}
.layer_01 .layer-text {
  /* padding: 10px; */
  text-align: center;
  max-width: 90%; /* 文字が画像からはみ出さないように最大幅を設定 */
  word-wrap: break-word; /* 長い単語が折り返されるようにする */
  color: #424242;
  font-weight: 500;
}
.layer_01 .layer-text .fs-2 {
  font-size: 2em;
}

.feature-row_product_list {
  align-items: inherit;
  justify-content: flex-start;
}
.feature-row_column_list {
  align-items: inherit;
  justify-content: center;
}
.feature-row_product_item {
  width: 25%;
  padding: 5px;
  text-align: center;
}
.feature-row_column_item {
  width: 33%;
  padding: 5px;
  text-align: center;
}
.feature-row_product_detail {
  color: #333;
}
.feature-row_product_cate {
  font-size: .8em;
  color: #6b6b67;
  opacity: .65;
}
.feature-row_voice_list {
  align-items: baseline;
}
.feature-row_voice_list path.a {
  fill: none;
  stroke: #000;
  stroke-width: 2px;
}
.feature-row_voice_list .icon svg {
  width: 70px;
}
.feature-row_voice_list .feature-row_voice_item {
  width: 33%;
  padding: 5px;
  text-align: center;
}

.box-top-slide {
  position: relative;
}
.img-top-slide img {
  width: 100%;
  height: 422px;
  object-fit: cover;
}
.img-top-slide_text {
  position: absolute;
  bottom: 30px;
  left: 30px;
}
.img-top-slide_text h2 {
  font-size: 2em;
  font-weight: 500 !important;
}
.img-top-slide_text h2 span {
  font-size: .6em;
}

.layer_02 .layer-text,.layer_03 .layer-text,.layer_04 .layer-text {
  background-color: #cacaca;
  padding: 10px;
}
.layer_02 .layer-text .layer-text-inner,.layer_03 .layer-text .layer-text-inner,.layer_04 .layer-text .layer-text-inner {
  background-color: #fff;
  padding: 15px;
}
.layer_02 .layer-text .layer-text-inner h2 span,.layer_03 .layer-text .layer-text-inner h2 span,.layer_04 .layer-text .layer-text-inner h2 span {
  font-size: .6em;
}
@media screen and (min-width: 991px) {
    .layer_02 {
      position: relative;
      display: flex;
      align-items: flex-start;
      background-image: url('../../assets/img/column/202501_05.jpg');
      background-size: cover;
      min-height: 600px;
      padding: 60px;
    }
    .layer_03 {
      position: relative;
      display: flex;
      align-items: flex-start;
      background-image: url('../../assets/img/column/202501_06.jpg');
      background-size: cover;
      min-height: 600px;
      padding: 60px;
    }
    .layer_04 {
      position: relative;
      display: flex;
      align-items: flex-start;
      background-image: url('../../assets/img/column/202501_07.jpg');
      background-size: cover;
      min-height: 600px;
      padding: 60px;
    }
    .layer_02 img,.layer_03 img,.layer_04 img {
      display: none; /* 画像は背景として使用するので非表示にします */
    }
    .layer_02 .layer-text,.layer_03 .layer-text,.layer_04 .layer-text {
      padding: 15px;
      max-width: 45%; /* 文字が画像からはみ出さないように最大幅を設定 */
      word-wrap: break-word; /* 長い単語が折り返されるようにする */
      color: #424242;
      background-color: #fff;
    }
}
@media screen and (max-width: 699px) {
    .img-top-slide_text h2 {
      font-size: inherit;
    }
    .img-top-slide_text h2 span {
      font-size: .8em;
    }
    .img-top-slide_text {
      left: 10px;
    }
}
@media screen and (min-width: 769px) {
   .feature-row_item_text_right {
    padding-left: 60px;
   }
   .feature-row_item_text_left {
    padding-right: 60px;
   }
   .w-40 {
    width: 40%;
   }
   .w-60 {
    width: 60%;
   }
   .feature-row.step .step-item {
    width: 33.33%;
   }
   .img-top-slide img {
    height: 650px;
   }
}
@media screen and (min-width: 1px) and (max-width: 768px) {
  .column_content h2 {
    margin-bottom: 40px;
  }
  .feature-row {
    flex-direction: column;
  }
  .feature-row_item_image {
    order: 1;
    margin-bottom: 15px;
  }
  .feature-row_item_text {
    order: 2;
  }
  .feature-row_voice_item, .feature-row_product_item, .feature-row_column_item {
      width: 100% !important;
  }
  .w-50, .w-25, .w-75 {
    width: 100% !important;
  }
  .layer-text {
    font-size: .8em;
  }
  .layer_01 .layer-text .fs-2 {
    font-size: 1.5em;
  }
}
</style>

<script>
import $ from "jquery";

$(function() {
 var topBtn = $('#page-top');    
 topBtn.hide();
 //スクロールが500に達したらボタン表示
 $(window).scroll(function () {
 if ($(this).scrollTop() > 500) {
 topBtn.fadeIn();
        } else {
 topBtn.fadeOut();
        }
    });
    
});

// ページ内リンク
export default{
  data: () => {
    return {isActive: []}
  },
  mounted (){
    window.scroll(0, 0);
    for(let i = 0; i < 2; i++) {
      this.isActive[i] = false
    }
  },
  methods: {
    scrollToAnchorPoint(refName) {
      const el = this.$refs[refName]
      el.scrollIntoView({ behavior: 'smooth'})
    },
    openInfo(ref) {
      console.log(ref)
      this.isActive[ref] = true
      console.log(this.isActive[ref])
    },
    closeInfo(ref) {
      console.log(ref)
      this.isActive[ref] = false
      console.log(this.isActive[ref])
    },
    scrollTop(){
      window.scrollTo({
      top: 0,
      behavior: "smooth"
      })
    }
  }
}

</script>